import { render, staticRenderFns } from "./ApprovePage.vue?vue&type=template&id=f2b9b46a&scoped=true&"
import script from "./ApprovePage.ts?vue&type=script&lang=ts&"
export * from "./ApprovePage.ts?vue&type=script&lang=ts&"
import style0 from "./ApprovePage.vue?vue&type=style&index=0&id=f2b9b46a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b9b46a",
  null
  
)

export default component.exports